var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"input-text",class:{ block: _vm.block },style:(_vm.style),attrs:{"disabled":_vm.disabled},domProps:{"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }